import React from 'react';
import { Navigate } from 'react-router-dom';

// Páginas com uso INCONCLUSIVO na auditoria
// (docs/RELATORIO_AUDITORIA_INDIVIDUAL_LOTE.md). Acessíveis por URL direta
// somente com REACT_APP_SHOW_LEGACY_PAGES=true.
const SHOW_LEGACY_PAGES = process.env.REACT_APP_SHOW_LEGACY_PAGES === 'true';

function LegacyRoute({ children }) {
  return SHOW_LEGACY_PAGES ? children : <Navigate to="/pecas" replace />;
}

export default LegacyRoute;
